import { render, staticRenderFns } from "./AbkCompetenceTrainingBox.vue?vue&type=template&id=86050588&scoped=true&"
import script from "./AbkCompetenceTrainingBox.vue?vue&type=script&lang=js&"
export * from "./AbkCompetenceTrainingBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkCompetenceTrainingBox.vue?vue&type=style&index=0&id=86050588&scoped=true&lang=scss&"
import style1 from "./AbkCompetenceTrainingBox.vue?vue&type=style&index=1&id=86050588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86050588",
  null
  
)

export default component.exports